(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const wishlistHeroHeartPath =
    'M16 28.5 4.9 17.8C1.6 14.6 1 12.2 1 10.1 1 6.1 4.1 3 8.1 3c3 0 5.3 1.7 7.9 4.6C18.6 4.7 20.9 3 23.9 3 27.9 3 31 6.1 31 10.1c0 2.1-.6 4.5-3.9 7.7L16 28.5z';

  const getWishlistIconColor = (values) =>
    values.find((value) => value && value !== 'none' && value !== 'transparent' && value !== 'rgba(0, 0, 0, 0)') ||
    'currentColor';

  const replaceWishlistHeroIconPath = () => {
    document.querySelectorAll('.wishlist-hero-header-icon svg').forEach((svg) => {
      const currentPath = svg.querySelector('path');
      const iconWasReplaced = svg.dataset.pureDermWishlistIcon === 'true';
      const svgStyles = window.getComputedStyle(svg);
      const pathStyles = currentPath ? window.getComputedStyle(currentPath) : null;
      const iconColor = getWishlistIconColor([
        !iconWasReplaced && currentPath?.getAttribute('stroke'),
        !iconWasReplaced && currentPath?.getAttribute('fill'),
        svg.getAttribute('stroke') ||
          svg.getAttribute('fill'),
        !iconWasReplaced && pathStyles?.stroke,
        !iconWasReplaced && pathStyles?.fill,
        svgStyles.stroke,
        svgStyles.fill,
        svgStyles.color,
      ]);

      if (iconWasReplaced && currentPath?.getAttribute('d') === wishlistHeroHeartPath) {
        if (currentPath.getAttribute('stroke') !== iconColor) currentPath.setAttribute('stroke', iconColor);
        return;
      }

      svg.setAttribute('viewBox', '0 0 32 32');
      svg.innerHTML = `<path fill="none" stroke="${iconColor}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" d="${wishlistHeroHeartPath}"></path>`;
      svg.dataset.pureDermWishlistIcon = 'true';
    });
  };

  const normalizeMenuDrawerWishlistCount = () => {
    document.querySelectorAll('.menu-drawer__wishlist .wishlist-hero-items-count').forEach((count) => {
      const rawCount = count.textContent.trim();
      const countNumber = rawCount.match(/^\(?(\d+)\)?$/)?.[1];

      if (!countNumber) return;

      const formattedCount = ` (${countNumber})`;
      if (count.textContent !== formattedCount) count.textContent = formattedCount;
    });
  };

  const syncWishlistHeroHeader = () => {
    replaceWishlistHeroIconPath();
    normalizeMenuDrawerWishlistCount();
  };

  syncWishlistHeroHeader();
  new MutationObserver(syncWishlistHeroHeader).observe(document.documentElement, {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true,
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
